import { ReactNode } from "react";
interface MenuItemProps {
    menu_title: string,
    menu_icon: ReactNode,
    onClick?: () => void,
    active_menu?: boolean
}

const MenuItem = (props: MenuItemProps) => {
    return (
        <div className='flex flex-row cursor-pointer select-none pr-[0.5px] py-0.5' onClick={props.onClick}>
            <div className={`flex justify-center items-center h-full w-full text-gray-600 hover:text-white group duration-300 transform hover:bg-green-600 transition ease-linear py-2 ${props.active_menu ? "bg-customPrimary hover:opacity-90" : ""} rounded-sm`}>
                <div className='flex flex-col items-center'>
                    <div className={`px-2 text-[27px] group-hover:text-white text-green-600 dark:text-white-100 ${props.active_menu ? "text-white" : ""} `}>{props.menu_icon}</div>
                    <h2 className={`mt-0.5 font-semibold text-[9px] group-hover:text-white drop-shadow-lg font-public-sans dark:text-green-200 ${props.active_menu ? "text-white" : ""} uppercase `}>{props.menu_title}</h2>
                </div>
            </div>
        </div>
    )
}

export default MenuItem